import { Spacer } from "./ui/spacer";

export function ListSectionFooter() {
  return <Spacer y="lg" />;
}
